export default "__VITE_ASSET__DOkExcBO__"